import { request } from "./httpClient";

function getBaseUrl(prefixKey) {
  const prefix = window.appConfig && window.appConfig[prefixKey];
  return process.env.REACT_APP_API_URL + prefix;
}

const energyDataKeyStrategies = {
  metrics: (siteId, start_time, end_time, offset, limit) => {

    const url = new URL(`${getBaseUrl("metricsPrefix")}${siteId}`);
    url.searchParams.set("start_time", start_time);
    url.searchParams.set("end_time", end_time);
    url.searchParams.set("offset", offset);
    url.searchParams.set("limit", limit);
    return {
      url,
      method: "GET",
      timeoutKey: "getTimeout",
    };
  },
  entsoe_prices: (start_date, end_date, country_code, resolution) => {

    const url = new URL(`${getBaseUrl("entsoePricesPrefix")}`);
    url.searchParams.set("start_time", start_date);
    url.searchParams.set("end_time", end_date);
    url.searchParams.set("country_code", country_code);
    url.searchParams.set("resolution", resolution);
    return {
      url,
      method: "GET",
      timeoutKey: "getTimeout",
    };
  },
  solar_forecasts: (site_id, start_date, end_date) => {

    const url = new URL(`${getBaseUrl("solarForecastsPrefix")}${site_id}`);
    url.searchParams.set("start_date", start_date);
    url.searchParams.set("end_date", end_date);
    return {
      url,
      method: "GET",
      timeoutKey: "getTimeout",
    };
  },
  latest_device_health: (site_id) => {

    const url = new URL(`${getBaseUrl("latestDeviceHealthCheckPrefix")}${site_id}`);
    return {
      url,
      method: "GET",
      timeoutKey: "getTimeout",
    };
  },
  latest_alerts: (site_id, limit = 1) => {
    const url = new URL(`${getBaseUrl("latestAlertsPrefix")}${site_id}`);
    url.searchParams.set("limit", String(limit));
    return {
      url,
      method: "GET",
      timeoutKey: "getTimeout",
    };
  }
};

function masterEnergyDataCall(energyDataKey, ...params) {
  const strategy = energyDataKeyStrategies[energyDataKey];
  if (!strategy) {
    throw new Error(`No strategy found for ${energyDataKey}`);
  }
  const { url, method, timeoutKey, body } = strategy(...params);
  const timeout = window.appConfig && window.appConfig[timeoutKey];
  const options = { method };
  if (body !== undefined) {
    options.body = typeof body === "string" ? body : JSON.stringify(body);
  }
  return request(url.toString(), options, timeout);
}

export const metricsApi = {
  getMetrics(siteId, start_time, end_time, offset = 0, limit = 100) {
    return masterEnergyDataCall(
      "metrics",
      siteId, start_time, end_time, offset, limit
    );
  },

  async getAllMetrics(siteId, start_time, end_time, pageSize = 100) {
    let all = [];
    let offset = 0;
    while (true) {
      const page = await this.getMetrics(
        siteId, start_time, end_time, offset, pageSize
      );
      if (!Array.isArray(page) || page.length === 0) {
        break;
      }
      all.push(...page);
      if (page.length < pageSize) {
        break;
      }
      offset += page.length;
    }
    return all;
  }
};

export const pricesApi = {
  getData(start_date, end_date, country_code, resolution = "hourly") {
    return masterEnergyDataCall(
      "entsoe_prices",
      start_date, end_date, country_code, resolution
    );
  }
};

export const solarApi = {
  getData(site_id, start_date, end_date) {
    return masterEnergyDataCall(
      "solar_forecasts",
      site_id, start_date, end_date
    );
  }
};


export const deviceHealthApi = {
  getData(site_id) {
    return masterEnergyDataCall(
      "latest_device_health",
      site_id
    );
  }
};

export const alertsApi = {
  getData(site_id, limit = 1) {
    return masterEnergyDataCall("latest_alerts", site_id, limit);
  },
};